import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import {
  dropBoolean,
  dropTipoAcidente,
  dropOrgaoDeClasse,
  dropNaoUso,
  dropNaoRemuneracao,
  dropOrgRetificacao,
} from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Afastamento = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const afastamentos = pessoal?.Afastamentos ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalAfastamento',
      id: item?.id,
      pessoal_id: pessoal?.id,
      afastamento_id: item?.afastamento_id || null,
      dtiniafast: item?.dtiniafast || null,
      dttermafast: item?.dttermafast || null,
      qtddiasafast: item?.qtddiasafast || '',
      infomesmomot: item?.infomesmomot || null,
      observacao: item?.observacao || '',
      codcid: item?.codcid || '',
      tpacidtransito: item?.tpacidtransito || null,
      nmemit: item?.nmemit || '',
      ideoc: item?.ideoc || null,
      nroc: item?.nroc || '',
      ufoc_id: item?.ufoc_id || null,
      cnpjcess: item?.cnpjcess || '',
      cnpjsind: item?.cnpjsind || '',
      infonus: item?.infonus || null,
      infonusremun: item?.infonusremun || null,
      origretif: item?.origretif || null,
      entidade_processos_id: item?.entidade_processos_id || null,
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Identificação do Afastamento" disableMargin />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            name="afastamento_id"
            control={control}
            label="Tipo de Afastamento"
            options={drops?.Afastamento}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            type="date"
            name="dtiniafast"
            control={control}
            label="Data de Início"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            type="date"
            control={control}
            name="dttermafast"
            label="Data de Término"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            control={control}
            name="qtddiasafast"
            label="Quantidade de Dias"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Dropdown
            control={control}
            name="infomesmomot"
            options={dropBoolean}
            label="Mesmo Motivo de Afastamento Anterior"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            rows={3}
            multiline
            name="observacao"
            control={control}
            label="Observação"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Motivo Médico / Acidente" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input name="codcid" control={control} label="Código CID" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            name="tpacidtransito"
            options={dropTipoAcidente}
            label="Tipo de Acidente de Trânsito"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Dados do Atestado / Emitente" />
        </Grid>
        <Grid item xs={12}>
          <Input name="nmemit" control={control} label="Nome do Emitente" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="ideoc"
            control={control}
            label="Órgão de Classe"
            options={dropOrgaoDeClasse}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input
            name="nroc"
            control={control}
            label="Nº de Registro no Órgão de Classe"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="ufoc_id"
            control={control}
            options={drops?.UF}
            label="UF do Órgão de Classe"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Informações Complementares" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            name="cnpjcess"
            control={control}
            label="CNPJ da Empresa Cessionária"
            mask="99.999.999/9999-99"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            name="cnpjsind"
            control={control}
            label="CNPJ do Sindicato"
            mask="99.999.999/9999-99"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="infonus"
            control={control}
            options={dropNaoUso}
            label="Informação de Não Uso"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            control={control}
            name="infonusremun"
            options={dropNaoRemuneracao}
            label="Informação de Não Remuneração"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="origretif"
            control={control}
            options={dropOrgRetificacao}
            label="Origem da Retificação"
          />
        </Grid>
        <Grid item xs={12}>
          <Dropdown
            control={control}
            name="entidade_processos_id"
            label="Processo Relacionado"
            options={drops?.EntidadeProcessos?.filter(
              (f) => f?.entidade_id === pessoal?.funcionario_id
            )}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Afastamentos"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Afastamento')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={afastamentos}
          columns={[
            {
              field: 'afastamento',
              headerName: 'Tipo',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'dtiniafast',
              headerName: 'Data de Início',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'dttermafast',
              headerName: 'Data de Término',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'qtddiasafast',
              headerName: 'Dias',
              width: 100,
              sortable: false,
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Afastamento')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalAfastamento', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Afastamento;
